import api from 'services/api';

const parseDownloadFileName = (contentDisposition: string | undefined, fallbackName: string): string => {
  if (!contentDisposition) return fallbackName;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const quotedMatch = contentDisposition.match(/filename="([^"]+)"/i);
  if (quotedMatch?.[1]) {
    return quotedMatch[1];
  }

  const plainMatch = contentDisposition.match(/filename=([^;\n]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim();
  }

  return fallbackName;
};

const parseBlobErrorMessage = async (error: any, fallbackMessage: string): Promise<string> => {
  const blobPayload = error?.response?.data;

  if (blobPayload instanceof Blob) {
    const text = await blobPayload.text();
    try {
      const parsed = JSON.parse(text);
      return parsed?.error || parsed?.message || fallbackMessage;
    } catch {
      return text || fallbackMessage;
    }
  }

  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  if (error?.message) {
    return error.message;
  }

  return fallbackMessage;
};

export const downloadNodeInstanceDirectory = async (nodeInstanceId: number | string): Promise<void> => {
  const response = await api.get(`/node_instances/${nodeInstanceId}/directory`, {
    responseType: 'blob',
  });

  const fallbackName = `node_instance_${nodeInstanceId}_directory.zip`;
  const fileName = parseDownloadFileName(response.headers?.['content-disposition'], fallbackName);

  const blobUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

export const getNodeInstanceDirectoryDownloadError = async (error: any): Promise<string> => {
  return parseBlobErrorMessage(error, 'Failed to download node instance directory');
};
